import axios from "axios";
import instanceTokenLess from "../../../axiosTokenLess";
import instance from "../../../axios";


export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export const API_URL = `${process.env.REACT_APP_API_URL}/html5-games`;
export const API_URLCATGR = `${process.env.REACT_APP_API_URL}/html5-categories`;

// CREATE =>  POST: add a new StaffUser to the server
export function createItem(item) {
  return instanceTokenLess.post(`${API_URL}/create`, item)
  .then(res => {
      return res;
  })
};
export function fetchCountriesDropdownList(queryParams) {
  if(queryParams?.code){
    return instance
    .post(`${BASE_URL}/v3/dropdown/country/short/${queryParams?.code}`)
    .then((res) => {
      return res;
    });
  }else{
    return instance
    .post(`${BASE_URL}/country/Dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
  }
}
export function fetchHTML5CategoryListCompanywise(queryParams) {
  return instanceTokenLess.post(`${API_URLCATGR}/search`, queryParams)
  .then(res => {
      return res;
  })
};


export function getCompany(queryParams) {
  return instance
    .post(`${BASE_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}
export function fetchCompanyDropdownList(queryParams) {
  return instance
    .post(`${process.env.REACT_APP_API_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}
// READ
export function getList(queryParams) {
  return instanceTokenLess.post(`${API_URL}/list`, queryParams)
  .then(res => {
      return res;
  })
};
// READ
export function getJoingList(queryParams) {
  return instanceTokenLess.post(`${API_URL}/joining-list`, queryParams)
  .then(res => {
    return res;
})
}
export function getGameWiseJoingList(queryParams) {
  return instanceTokenLess.post(`${API_URL}/game-wise-joining-list`, queryParams)
  .then(res => {
    return res;
})
}
 
export function getItemById(id) {
  const selectedCompany = localStorage.getItem('selectedCompany');
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    id: id,
    company: selectedCompany, 
  };
  return instanceTokenLess.post(`${API_URL}/get/${id}`, payload)
  .then(res => {
      return res;
  })
};

export function getSetting(queryParams) {
  const payload = {
    company: queryParams?.companyCode,
  };
  return instanceTokenLess.post(`${process.env.REACT_APP_API_URL}/html5-settings/get/${queryParams?.id}`, payload);
}


// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findItem(queryParams) {
  return instanceTokenLess.post(`${API_URL}/find`, { queryParams })
  .then(res => {
    return res;
})
}

// UPDATE => PUT: update the StaffUser on the server
export function updateItem(item) {
  return instanceTokenLess.post(`${API_URL}/update/${item._id}`, item)
  .then(res => {
      return res;
  })
};
export function updateStatus(item) {
  return instanceTokenLess.post(`${API_URL}/status/${item._id}`, item)
  .then(res => {
      return res;
  })
};
// UPDATE => PUT: update the StaffUser on the server
export function updateSetting(item) {
  return instanceTokenLess.post(`${process.env.REACT_APP_API_URL}/html5-settings/update/${item._id}`, item)
  .then(res => {
    return res;
})
}
// UPDATE => PUT: update the StaffUser on the server
export function createSetting(item) {
  return instanceTokenLess.post(`${process.env.REACT_APP_API_URL}/html5-settings/create/`, item)
  .then(res => {
    return res;
})
}

// UPDATE Status
export function updateItemsStatus(ids, status) {
  return instanceTokenLess.post(`${API_URL}/updateStatusForitems`, {
    ids,
    status
  })
    .then((res) => {
    return res;
  });
}

// DELETE => delete the StaffUser from the server

export function deleteItem(id) {
  const selectedCompany = localStorage.getItem('selectedCompany');
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    id: id,
    company: selectedCompany, 
  };
  return instanceTokenLess.post(`${API_URL}/delete/${id}`, payload)
  .then(res => {
      return res;
  })
};

// DELETE items by ids
export function deleteItems(ids,  company = "gj") {
  const payload = {
    company: company.trim().toLowerCase(),
    ids: ids
  };
  return instanceTokenLess.post(`${API_URL}/deleteitems`,payload)
  .then(res => {
    return res;
})
}
 